module.exports = __webpack_public_path__ + "img/features2.4e4445d6.jpg";